/** Hides the header when scrolling down and the screen is past it. Unhides it when scrolling up. */
const hide_on_scroll = (header) => {
	let scroll_y = window.scrollY;
	const scrolled_down = () => window.scrollY > scroll_y;
	const listener = (scroll_event) => {
		if (scrolled_down()) {
			header.classList.add("!h-0");
		} else {
			header.classList.remove("!h-0");
		}
		scroll_y = window.scrollY;
	};
	window.addEventListener("scroll", listener);
};

for (const header of document.getElementsByClassName("group/header")) {
	hide_on_scroll(header);
}